<script setup>
import { inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCookies } from '@vueuse/integrations/useCookies'

import CookiesPopup from '@dogfy/components/widgets/CookiesPopup.vue'

import config from '@/config'

const gtm = inject('gtm')

const { locale } = useI18n()

const { key: cookieConsentKey, ...cookieConsentOptions } = config.cookies.consent
const cookies = useCookies([cookieConsentKey])
const consentCookie = ref(cookies.get('consent'))

const websiteUrl = import.meta.env.VUE_APP_WEBSITE_URL
const legalWarningLink = config.dogfyLinks.legal.find(({ langKey }) => langKey === 'legalWarning')
const privacyUrl = `${websiteUrl}${legalWarningLink.path[locale.value]}`

function saveSettings () {
  cookies.set(cookieConsentKey, consentCookie.value, { maxAge: cookieConsentOptions.expires, domain: new URL(websiteUrl).hostname })

  gtm.consentChange({
    consent_type: {
      needed: true,
      security: true,
      statistics: consentCookie.value.analytics,
      marketing: consentCookie.value.ad,
    },
  })
}
</script>

<template>
  <CookiesPopup
    v-model="consentCookie"
    image="/images/dog-cookies.png"
    :privacy-url="privacyUrl"
    @save="saveSettings"
  />
</template>
